import { createSvgComponent } from "../../icon/createSvgComponent";
import RecommFill from "@core/icon/assets/recomm-fill.svg";
export default createSvgComponent(RecommFill);